module.exports = __webpack_public_path__ + "static/media/pdficon.19d6ca38.svg";